<template>
  <section class="c-it-support">
    <h2>Need help?</h2>
    <p>No problem contact the IT Service desk on:</p>

    <h3>Oxford Road</h3>
    <p class="m-top-5 m-bottom-20">
      <a href="tel:0161 701 2020">0161 701 2020</a>
    </p>

    <h3>Wythenshawe Site</h3>
    <p class="m-top-5 m-bottom-20">
      <a href="tel:0161 291 2820">0161 291 2820</a>
    </p>
  </section>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.c-it-support {
  height: 100%;

  h2 {
    font-family: $font-frutiger-light;
  }

  h3 {
    margin-bottom: 0;
    padding-bottom: 0;
  }

  a {
    color: $colour-nhs-black;
    text-decoration: none;
    font-size: 1.5rem;
  }
}
</style>